function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M282.872 130.304c-6.057-8.631-21.288-15.045-41.194-9.049-18.278 5.506-26.469 34.756-2.628 45.998 3.741 1.764 13.327 5.53 27.79 10.642 32.37 11.442 33.434 53.956-4.984 57.312-12.801 1.118-31.056.677-40.769-11.382M254.418 236.546v9.907M254.418 106.438v11.776M184.021 327.158h143.958M184.021 405.562h143.958",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.14 332.362V116.546a59.996 59.996 0 0 0-17.574-42.426L376.02 37.574A59.996 59.996 0 0 0 333.594 20H141.86c-33.137 0-60 26.863-60 60v352c0 33.137 26.863 60 60 60h228.28c33.016 0 59.804-26.668 59.999-59.638",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: "",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockReport);
export default __webpack_public_path__ + "static/media/stock-report.60cb497a45fbc340130bf6c4d834bef2.svg";
export { ForwardRef as ReactComponent };